import React from 'react';
import './style.scss';
import { RodapeUsemais } from '../../componentes/organisms/RodapeUsemais';

const Manutencao: React.FC = () => {
  return (
    <>
    <div className="container">
      <p className="message">
        Para oferecer uma experiência cada vez melhor, nossa plataforma está passando por uma manutenção programada.
        <br /><br />
        Voltamos em breve!
        <br /><br />
        Agradecemos sua compreensão.
      </p>
    </div>

    
    <RodapeUsemais />
    </>
  );
};

export default Manutencao;
